import { ModuleWithProviders, NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import {HomeComponent} from '@core/pages/home/home.component'
import { AuthGuard } from '@core/guards/auth.guard';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "clientes",
    loadChildren: () =>
      import("./modules/clientes/clientes.module").then(m => m.ClientesModule)
  },
  {
    path: "account",
    loadChildren: () =>
      import("./modules/account/account.module").then(m => m.AccountModule)
  },
  {
    path: "visitas",
    loadChildren: () =>
      import("./modules/visitas/visitas.module").then(m => m.VisitasModule)
  },
  {
    path: "parametrizacao",
    loadChildren: () =>
      import("./modules/parametrizacao/parametrizacao.module").then(m => m.ParametrizacaoModule)
  },
  {
    path: "cartao",
    loadChildren: () =>
      import("./modules/cartao/cartao.module").then(m => m.CartaoModule)
  },
  {
    path: "video",
    loadChildren: () =>
      import("./modules/videos/video.module").then(m => m.VideoModule)
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
